$(document).ready(function(){
    $(".js-abstand").each(function () {
        var $elmentBefore = $(this).prev();
        var $elmentNext = $(this).next();
        var abstand = $(this).data("abstand");

        if(abstand == "no"){
            if($elmentBefore.hasClass("helper_site-content__section-no_top") || $elmentBefore.hasClass("helper_site-content__section-no_both")){
                $elmentBefore.addClass("helper_site-content__section-no_both");
                $elmentBefore.removeClass("helper_site-content__section-no_top");
            }else{
                $elmentBefore.addClass("helper_site-content__section-no_button");
            }

            if($elmentNext.hasClass("helper_site-content__section-no_button") || $elmentNext.hasClass("helper_site-content__section-no_both")){
                $elmentNext.addClass("helper_site-content__section-no_both");
                $elmentNext.removeClass("helper_site-content__section-no_button");
            }else{
                $elmentNext.addClass("helper_site-content__section-no_top");
            }
        }
    });

    $.extend({
        replaceTag: function (currentElem, newTagObj, keepProps) {
            var $currentElem = $(currentElem);
            var i, $newTag = $(newTagObj).clone();
            if (keepProps) {//{{{
                newTag = $newTag[0];
                newTag.className = currentElem.className;
                $.extend(newTag.classList, currentElem.classList);
                $.extend(newTag.attributes, currentElem.attributes);
            }//}}}
            $currentElem.wrapAll($newTag);
            $currentElem.contents().unwrap();
            // return node; (Error spotted by Frank van Luijn)
            return this; // Suggested by ColeLawrence
        }
    });

    $.fn.extend({
        replaceTag: function (newTagObj, keepProps) {
            // "return" suggested by ColeLawrence
            return this.each(function() {
                jQuery.replaceTag(this, newTagObj, keepProps);
            });
        }
    });

    $(".js-cookie_overlay_button-all").on("click", function(e){
        e.preventDefault();
        $(".js-cookie_overlay_form").find("input").prop("checked", true)
        ajaxCookie();
    });

    $(".js-cookie_overlay_button").on("click", function(e){
        e.preventDefault();
        ajaxCookie();
    });

    function ajaxCookie(){
        $.ajax({
            url:$(".js-cookie_overlay_form").attr("action"),
            type:'POST',
            data: $(".js-cookie_overlay_form").serialize() + "&unset=google;youtube",
        }).done(function(html){
            $("#cookie-notice").hide(100);
        });
    }

    $(document).ready(function() {
        $('.image-link').magnificPopup({type:'image'});
    });

    $('.js-table_gallery').each(function() { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a', // the selector for gallery item
            type: 'image',
            gallery: {
                enabled:true
            }
        });
    });

    $(".js-open_cookie_overlay").on("click", function(e){
        e.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.set("display", 1);
        window.location.href = url.toString(); // This causes a reload
    })

    $(function () {
        $('[data-toggle="tooltip"]').tooltip({template: 	'<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'})
    })

    $('.js-product-overlay-open').on('click', function(e) {
        e.preventDefault();

        let idCb = $(this).data("id_cb");
        let row = $(this).data("id_row");
        let idLang = $(this).data("id_lang");
        let ajaxPath = $(this).data("ajax_product_overlay_data");
        let overlayData = fetchProductOverlayData(idCb,row,idLang,ajaxPath);
        populateProductOverlay(overlayData);

        $('.product-overlay').addClass('product-overlay-active')
        $('body').addClass('product-overlay-open');
    });

    $('.js-product-overlay-close').on('click', function(e) {
        e.preventDefault();
        $('.product-overlay').removeClass('product-overlay-active')
        $('body').removeClass('product-overlay-open');
    });
});

function fetchProductOverlayData(idCb,row,idLang,ajaxPath){

let data;
    $.ajax({
        url: ajaxPath,
        type: 'POST',
        async: false,
        data: {
            id_cb: idCb,
            id_row: row,
            id_lang: idLang
        },
        success: function(response) {
          data = JSON.parse(response);
        }
    });
    return data;
}

function populateProductOverlay(data){

    for(let i = 1; i <= 3; i++){
        let row = data['row_' + i];
        for(let j = 1; j <= 4; j++){
            let value = row['cell_' + j];
            if(value == ""){
                value = "&nbsp;";
            }
            $('#overlay_row_' + i + '_cell_' + j).html(value);
        }
    }

    $('#overlay_image').attr('src',data['jpg']['link']);

    let linktypesIcons = {'jpg': {'iconClass' : 'fa-image'},
                                'rtf': {'iconClass' : 'fa-file-alt'},
                                'pdf': {'iconClass' : 'fa-file-pdf'},
                                'stp': {'iconClass' : 'fa-cube'},
                                'stp_pdf': {'iconClass' : 'fa-file-pdf'},
                                'dwg': {'iconClass' : 'fa-draw-polygon'}};

    let overlayFileContainer = $('#overlay_file_container').empty();
    for(let linktype in linktypesIcons){
        if(data[linktype] != ""){
            let download = linktype == 'stp' ?  "download" : "";
            let iconClass = linktypesIcons[linktype]['iconClass'];
            let link = data[linktype]['link'];
            let text = data[linktype]['text'];

            if(link == "" || text == "") continue;

            let html = "<span class='product-overlay-file'>" +
                "<span class='product-overlay-file-icon-container'>" +
                "<i class='fas "+ iconClass +"'></i>" +
                "</span><a href='"+ link + "' target='_blank' " + download + ">" + text + "</a></span>";
            overlayFileContainer.append(html);
        }
    }
}